<template>
  <div class="animation" ref="animation"></div>
</template>

<script>
import animation from '@/mixins/animation';
import clench from '@/assets/animations/clench.json';
import clenchSanne from '@/assets/sanne/animations/clench.json';

export default {
  name: 'Clench',
  mixins: [animation],
  // same animation and timing in every brand; Sanne gets a recoloured copy
  // (computed getters are not set up yet while data runs, so read the store)
  data() {
    return {
      animationData: this.$store.getters['app/isSanne'] ? clenchSanne : clench,
      autoPlay: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.animation {
  position: absolute;
  width: 330%;
  top: 34%;
  margin-left: 2%;
}
</style>
